export const limits = {
  INSIDE_SUBSIDIARY_COUNT: 5,
  OUTSIDE_SUBSIDIARY_COUNT: 5
};

export const MAX_TRADE_LICENSE_NUMBER = 12;
export const MAX_BANK_NAME_LENGTH = 50;

export const BASED_IN = [
  {
    code: "Within UAE",
    key: "Within UAE",
    value: "Within UAE",
    label: "Within UAE"
  },
  {
    code: "Outside UAE",
    key: "Outside UAE",
    value: "Outside UAE",
    label: "Outside UAE"
  }
];
